import { initializeGlobalErrorPopup } from "error-popup"
import "materia-scss/src/reset.scss"
import React from "react"
import ReactDOM from "react-dom/client"
import { setSentryUserContext } from "sentry/src/initializeSentry"
import { benchmark } from "utils"
import { App } from "./App"
import { initializeAppLauncher } from "./initialize/initializeAppLauncher"
import { initializeAuth } from "./initialize/initializeAuth"
import { initializeBackofficeApi } from "./initialize/initializeBackofficeApi"
import { initializeI18n } from "./initialize/initializeI18n"
import { initializeLeaderboardApi } from "./initialize/initializeLeaderboardApi"
import { initializeLocalise } from "./initialize/initializeLocalise"
import { initializePDFJsWorker } from "./initialize/initializePDFJsWorker"
import { initializePlausible } from "./initialize/initializePlausible"
import { initializeSentry } from "./initialize/initializeSentry"
import { initializeSharedDevice } from "./initialize/initializeSharedDevice"
import { initializeVuplex } from "./initialize/initializeVuplex"

// https://jira.attensi.com/browse/WEB-20905

// Those methods have to be awaited and invoked in this exact order.
// Awaiting too many init methods risks the app loading for too long.
// We benchmark them to see if it won't hinder UX too much.
const initializeTopLevel = async () => {
  await benchmark("INITIALIZATION_SENTRY", initializeSentry) // will show 0ms in local as it doesn't run there
  await benchmark("INITIALIZATION_VUPLEX", initializeVuplex)
  await benchmark("INITIALIZATION_AUTH", initializeAuth)
  // This needs to be called AFTER auth always!!!!
  setSentryUserContext()
}

await initializeTopLevel()

initializeAppLauncher()
initializeBackofficeApi()
initializeGlobalErrorPopup()
initializeI18n()
initializeLeaderboardApi()
initializeLocalise()
initializePDFJsWorker()
initializePlausible()
initializeSharedDevice()

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
